import React, { useContext } from "react";
import { AppBar, Box, Toolbar } from "@mui/material"; 
import LogoIcon from "../../assets/logo/logo-icon.png";
import LogoName from "../../assets/logo/logo-name.png";
import { ToggleContext } from "../../contexts/ToggleContext";
import ViewToggle from "./ViewToggle/ViewToggle";
import { UserButton, OrganizationSwitcher } from "@clerk/clerk-react";

const clerkLayoutAppearance = {
  layout: {
    shimmer: false,
  },
  elements: {
    organizationSwitcherTrigger: {
      fontFamily: "Inter",
      color: "black",
      padding: "4px 8px", 
      borderRadius: "4px", 
      "&:focus": {
        boxShadow: "none", 
      },
      ".cl-organizationSwitcherTriggerIcon": {
        display: "none",
      },
      ".cl-organizationPreviewTextContainer": {
        display: "none",
      },
      ".cl-avatarBox": {
        width: "27px",
        height: "27px",
      },
      ".cl-avatarImage": {
        width: "27px",
        height: "27px",
      },
    },
    userButtonTrigger: {
      direction: "rtl", 
      fontFamily: "Inter",
      width: "5em",
      padding: "4px", 
      borderRadius: "4px", 
      "&:focus": {
        boxShadow: "none", 
      },
      ".cl-internal-gpirto": {
        display: "none",
      },
    },
  },
};

const Navbar = ({ showViewToggle, onViewChange, activeView }) => {
  const { showDashedLines, setShowDashedLines } = useContext(ToggleContext);

  return (
    <AppBar
      position="fixed" 
      sx={{
        backgroundColor: "#ffffff", 
        boxShadow: "none", 
        borderBottom: "1px solid #e0e0e0", 
        elevation: 0, 
        zIndex: (theme) => theme.zIndex.drawer + 1, 
      }}
    >
      <Toolbar
        disableGutters 
        sx={{
          minHeight: "64px !important", 
        }}
      >
        <Box 
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            px: 2, 
          }}
        >
          <Box 
            sx={{
              display: "flex",
              gap: "1rem",
              alignItems: "center",
            }}
          >
            {/* Application Logos */}
            <img src={LogoIcon} alt={""} width={"37px"} />
            <img src={LogoName} alt={""} width={"130px"} />
          </Box>

          <Box 
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            {showViewToggle && (
              <ViewToggle
                activeView={activeView} 
                onViewChange={onViewChange} 
                checked={showDashedLines}
                onChange={(event) => setShowDashedLines(event.target.checked)} 
              />
            )}
          </Box>

          <Box 
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <OrganizationSwitcher
              hidePersonal={true}
              appearance={clerkLayoutAppearance}
            />
            <UserButton appearance={clerkLayoutAppearance} />
          </Box>
        </Box> 
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
